import { render, staticRenderFns } from "./GroupEntity.vue?vue&type=template&id=07895c10&scoped=true"
import script from "./GroupEntity.vue?vue&type=script&lang=js"
export * from "./GroupEntity.vue?vue&type=script&lang=js"
import style0 from "./GroupEntity.vue?vue&type=style&index=0&id=07895c10&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07895c10",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07895c10')) {
      api.createRecord('07895c10', component.options)
    } else {
      api.reload('07895c10', component.options)
    }
    module.hot.accept("./GroupEntity.vue?vue&type=template&id=07895c10&scoped=true", function () {
      api.rerender('07895c10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/GroupEntity.vue"
export default component.exports